var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_c8b8e65c"]},_vm.$listeners),[_c('div',[_c('div',{class:["picker-demo-title"]},[_vm._v("order-picker:")]),_c('cube-date-picker',{attrs:{"min":(_vm.min),"max":(_vm.max),"value":(_vm.value),"columnOrder":(_vm.columnOrder)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }